import { Gamecloud } from "../../../../gamecloud";

export class PresetUI extends Gamecloud {

  public presetElement: JQuery = $('[data-name="preset"]');
  public typeElement: JQuery = $('[data-name="serverType"]');

  public constructor() {
    super();
  }

  public onTypeChange(callback: (value: string) => void) {
    this.typeElement.on('change', (event) => {
      callback(this.typeElement.val() as string);
    });
  }

  public onPresetChange(callback: (value: string) => void) {
    this.presetElement.on('change', () => {
      callback(this.presetElement.val() as string);
    });
  }
}
